module.exports = __webpack_public_path__ + "static/media/project-thumbnail19.4cc806d1.jpg";